import { InputLayout as _InputLayout } from './input-layout';
import { InputLayoutSlot } from './slot';

export const InputLayout = Object.assign( _InputLayout, {
	Slot: InputLayoutSlot,
} );
